import { toRem } from "../../../../helpers/theme";

const style = () => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    "& .drawerTags": {
        "&_inputContainer": {
            marginTop: toRem(20),
        },
    },
});

export default style;
